import { object, boolean, nativeEnum, ZodIssueCode, z } from 'zod';
import isNil from 'lodash/isNil';

import { makeZodValidate } from '@occc-app/design-system';
import { isGreaterThan, isLessThan, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { AwardType } from '@occc-app/offerHelpers/types';
import { AwardPointsSchema, PartialAwardVouchersSchema } from '@occc/validation';

export const zodIncentivizeResponsesSchema = object({
  isEnabled: boolean(),
  awardType: nativeEnum(AwardType),
  awardPoints: z.any(),
  awardVouchers: z.any(),
  //
  // We can not use next approaches because of superRefine
  // Super refine does not prevent validating the schema if no issues passed from superRefine
  // As a result when superRefine is passed without issues because isEnabled is false -
  // awardPoints validation will be triggered and if not points provided return validation error
  // As a result form is valid, submit button disabled because no points provided.
  // We should avoid superRefine for validating complex object
  //
  // awardPoints: AwardPointsSchema.optional(),
  // awardVouchers: PartialAwardVouchersSchema.optional(),
}).superRefine((data, ctx) => {
  if (!data.isEnabled) return;

  if (
    data.awardType === AwardType.AwardPoints &&
    !AwardPointsSchema.safeParse(data.awardPoints).success
  ) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: IS_REQUIRED,
      path: ['awardPoints', 'points'],
    });
  }

  if (
    data.awardType === AwardType.AwardVouchers &&
    !PartialAwardVouchersSchema.safeParse(data.awardVouchers).success
  ) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: IS_REQUIRED,
      path: ['awardVouchers', 'voucheredOffer'],
    });
  }
});

export const zodWalletSchema = z
  .object({
    name: z.string({ required_error: IS_REQUIRED }).trim().min(1, IS_REQUIRED),
    question: z.string({ required_error: IS_REQUIRED }).trim().min(1, IS_REQUIRED),
    rangeMin: z.number({ required_error: IS_REQUIRED }),
    rangeMax: z.number({ required_error: IS_REQUIRED }),
    productGroup: z.object({}, { message: IS_REQUIRED }),
    countWalletBy: z.string({ required_error: IS_REQUIRED }),
    period: z.string({ required_error: IS_REQUIRED }),
    incentivizeResponses: zodIncentivizeResponsesSchema,
  })
  .superRefine((data, ctx) => {
    if (!isNil(data.rangeMax) && data.rangeMin >= data.rangeMax) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: isLessThan(data.rangeMax),
        path: ['rangeMin'],
      });
    }

    if (!isNil(data.rangeMin) && data.rangeMax <= data.rangeMin) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: isGreaterThan(data.rangeMin),
        path: ['rangeMax'],
      });
    }
  });

export const validateWallet = makeZodValidate(zodWalletSchema);
